import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NavigationInfo } from '@services/core-services/shortcuts.constants';

@Component({
  standalone: true,
  selector: 'app-shortcut-tooltip-panel',
  template: `
    <div class="navigation-tooltip">
      @if (!showKeysOnly) {
        <div class="menu-text">{{ info?.name }}</div>
      }
      <div class="shortcut-keys h4-reg">
        @for (k of info?.keys; track k; let i = $index) {
          <span class="key">
            {{ k }}
            @if (i < (info?.keys?.length ?? 0) - 1) {
              <span class="sep h5-reg"> + </span>
            }
          </span>
        }
      </div>
    </div>
  `,
  imports: [CommonModule],
})
export class ShortcutTooltipPanelComponent {
  @Input() info: NavigationInfo | null = null;
  @Input() showKeysOnly: boolean = false;
}
